import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The unearthed magic powered machina is more than 10 years ago operated by ancient 'experts'...`}</p>
    <h1>{`Reminder`}</h1>
    <p>{`Ok, here's my old sites 10+ years ago: `}<a parentName="p" {...{
        "href": "http://blog.sina.com.cn/u/1889114642"
      }}>{`http://blog.sina.com.cn/u/1889114642`}</a>{` . Some are in Chinese and others are poorly written English (perhaps even true for now 😉).`}</p>
    <p>{`Today, I just found an overdue `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`reminder`}</code>{` from sina that I should migrate my page or at least backup images: they shut down sina photo/image store after 2019 which reminds me they could dump my everything when for example they need extra disk usage some years later. Same reminder happened 10+ years ago as well when MSN shut down. It reminds me I should always backup ancient blog.`}</p>
    <img {...{
      "style": {
        "width": "100%",
        "maxWidth": "30rem"
      },
      "alt": "Good bye",
      "src": "https://drive.google.com/uc?export=view&id=1XlIHwNeQmrUH7udZ_NuG7fBUY90xgXUc"
    }}></img>
    <p>{`Also I hope github free land will be there forever...`}</p>
    <h1>{`Plan`}</h1>
    <p>{`Big plan: I need to recover my original post resources (e.g. images) from my backup tomb. I need also remove duplicate content if any. I copy and paste things to this blog one post when I am not lazy.`}</p>
    <p>{`Posts recover so far:`}</p>
    <ol>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2009-11-26-review-quaternion"
        }}>{`2009-11-26-review-quaternion`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2010-03-04-blend-color"
        }}>{`2010-03-04-blend-color`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2010-03-06-research-material"
        }}>{`2010-03-06-research-material`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2010-12-22-simple-experiment"
        }}>{`2010-12-22-simple-experiment`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2011-01-01-reading-list"
        }}>{`2011-01-01-reading-list`}</a></li>
      <li parentName="ol"><a parentName="li" {...{
          "href": "../2011-01-24-double-refraction"
        }}>{`2011-01-24-double-refraction`}</a></li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      